import { Component } from "react";
import { useLanguage } from "../context/LanguageContext";
import { captureException } from "../utils/sentry";

function ErrorFallbackUI() {
  const { t } = useLanguage();
  return (
    <div style={{
      minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center",
      flexDirection: "column", gap: 16, padding: 40,
    }}>
      <div style={{
        fontFamily: "'Noto Sans',sans-serif", fontSize: 22, fontWeight: 600,
        color: "var(--theme-text)",
      }}>
        {t("errors.boundaryTitle")}
      </div>
      <div style={{
        fontFamily: "'DM Sans',sans-serif", fontSize: 14,
        color: "rgba(var(--c-on-bg),0.4)", maxWidth: 420, textAlign: "center", lineHeight: 1.6,
      }}>
        {t("errors.boundaryBody")}
      </div>
      <button
        type="button"
        onClick={() => window.location.reload()}
        style={{
          padding: "10px 24px", borderRadius: 12, border: "none",
          background: "#c9a84c", color: "var(--theme-ink)",
          fontFamily: "'DM Sans',sans-serif", fontSize: 14, fontWeight: 600,
          cursor: "pointer",
        }}
      >
        {t("errors.refresh")}
      </button>
    </div>
  );
}

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    captureException(error, {
      extra: {
        componentStack: info?.componentStack,
      },
      tags: {
        source: "ErrorBoundary",
      },
    });
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return <ErrorFallbackUI />;
    }
    return this.props.children;
  }
}
